import React from "react";
import { useTranslation } from "react-i18next";
import { UnstyledButton } from "../Button/UnstalyedButton";

import { PrimaryButton } from "../Button";
import { IconSparkles, IconX } from "../icons";
import { PRODUCT_RELEASES_PAGE_URL, type ProductRelease } from "./types";

export type { ProductRelease } from "./types";
export { PRODUCT_RELEASES_PAGE_URL } from "./types";

export namespace ProductReleaseAnnouncement {
  export interface Props {
    release: ProductRelease;
    onDismiss: () => void;
  }
}

export function ProductReleaseAnnouncement({ release, onDismiss }: ProductReleaseAnnouncement.Props) {
  const { t } = useTranslation();

  return (
    <div
      className="fixed bottom-6 right-6 z-40 w-[min(100%-2rem,24rem)]"
      role="status"
      aria-live="polite"
      data-test-id="product-release-toast"
    >
      <div className="rounded-2xl border border-surface-outline bg-surface-base shadow-xl">
        <div className="flex items-start gap-3 p-4">
          <div className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-callout-info-bg text-callout-info-content">
            <IconSparkles size={18} aria-hidden="true" />
          </div>

          <div className="min-w-0 flex-1">
            <p className="text-xs text-content-dimmed">{t("New release")}</p>
            <p className="mt-0.5 text-sm font-medium text-content-base line-clamp-3">{release.title}</p>

            <div className="mt-3">
              <PrimaryButton
                size="sm"
                linkTo={PRODUCT_RELEASES_PAGE_URL}
                linkTarget="_blank"
                testId="product-release-read-more"
              >
                {t("View release")}
              </PrimaryButton>
            </div>
          </div>

          <UnstyledButton
            type="button"
            className="shrink-0 rounded-md p-1 text-content-subtle transition-colors hover:bg-surface-dimmed hover:text-content-base"
            ariaLabel={t("Dismiss")}
            testId="product-release-toast-dismiss"
            onClick={onDismiss}
          >
            <IconX size={16} />
          </UnstyledButton>
        </div>
      </div>
    </div>
  );
}
